import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Schedule } from '@/widgets/Schedule/ui/Schedule';
import type { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
import { getFormattedDate } from '@/shared/lib/date/getFormattedDate';
import { Button } from '@/shared/ui/button';
import type { ISchedule } from '@/entities/booking/model/types';
import type { IScheduleInMedcenter } from '@/entities/medcenter/model/types';
interface PhoneBookingSectionProps {
  nearestWorkDay: ISchedule | null;
  formattedSchedule: IScheduleInMedcenter[];
  shouldShowLimitVisualItems: boolean;
  onBookOnlineClick: () => void;
  onScheduleClick: (item: IScheduleInMedcenter) => void;
}
export const PhoneBookingSection: React.FC<PhoneBookingSectionProps> = ({
  nearestWorkDay,
  formattedSchedule,
  shouldShowLimitVisualItems,
  onBookOnlineClick,
  onScheduleClick
}) => {
  const t = useTranslations();
  const locale = useLocale() as LanguageCodeEnum;
  return <div className="p-4" data-sentry-component="PhoneBookingSection" data-sentry-source-file="PhoneBookingSection.tsx">
      <h3 className="text-base font-bold">{t('doctor.phoneAndDialog.book_online')}</h3>
      <p className="text-sm text-gray-500">{t('doctor.phoneAndDialog.main_text')}</p>

      {formattedSchedule.length > 0 && <div className="mt-4">
          <Schedule schedule={formattedSchedule} onScheduleClick={onBookOnlineClick} onScheduleItemClick={onScheduleClick} {...shouldShowLimitVisualItems && {
        limitVisualItems: 3
      }} />
        </div>}

      <Button className="mt-4 w-full" size="default" onClick={onBookOnlineClick} data-sentry-element="Button" data-sentry-source-file="PhoneBookingSection.tsx">
        {nearestWorkDay ? t('doctor.phoneAndDialog.book_for_date', {
        date: getFormattedDate(nearestWorkDay.date, {
          format: 'D MMMM',
          locale
        })
      }) : t('doctor.phoneAndDialog.action_btn')}
      </Button>
    </div>;
};